import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import "../../../../assets/css/page/MainLayout.scss";
import { Box, CssBaseline, useTheme } from "@mui/material";
import { leftMenuStyle } from "../../../../assets/MUIStyles/sidebarMenu";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import SettingsPhoneRoundedIcon from "@mui/icons-material/SettingsPhoneRounded";
import ConstantsIcon from "@mui/icons-material/Tune";
import { ReactComponent as CallHistoryIcon } from "../../../../assets/Images/CallHistoryIcon.svg";
import { ReactComponent as DasboardIcon } from "../../../../assets/Images/Dashboard.svg";
import { ReactComponent as LeftPointer } from "../../../../assets/Images/LeftPointer.svg";
import { ReactComponent as ProjectIcon } from "../../../../assets/Images/ProjectIcon.svg";
import { ReactComponent as QuickStartIcon } from "../../../../assets/Images/Quick start.svg";
import { ReactComponent as RightPointer } from "../../../../assets/Images/RightPointer.svg";
import { ReactComponent as SettingsIcon } from "../../../../assets/Images/SettingsIcon.svg";
import { ReactComponent as SupportIcon } from "../../../../assets/Images/SupportIcon.svg";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { ReactComponent as AdminIcon } from "../../../../assets/Images/Admin.svg";
import { ReactComponent as Call } from "../../../../assets/Images/Call.svg";
import { ReactComponent as SuccessIcon } from "../../../../assets/Images/SuccessProjectIcon.svg";
import { layoutStyles } from "../../../../assets/MUIStyles/mainLayout";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import TaskIcon from "@mui/icons-material/Task";
import { Signal, BarChart3 } from "lucide-react";
import NewRoutes from "./NewRoutes";
import ProjectSidebar from "./ProjectSidebar";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import {
  checkRolesAccess,
  hasCallHistoryAccess,
  hasCampaignsAccess,
  hasOnlyCallHistoryAccess,
  isAdmin,
  isVodexLoggedin,
} from "../../CommonComponents/Common";
import CommonPopup from "../../CommonComponents/PopUpCards/CommonPopup";
import LinkIcon from "@mui/icons-material/Link";
import PaymentIcon from "@mui/icons-material/AccountBalanceWallet";
import BlockIcon from "@mui/icons-material/Block";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import SettingsPhoneOutlinedIcon from "@mui/icons-material/SettingsPhoneOutlined";

const menu = [
  // {
  //   id: "quick_start",
  //   text: "Quick start",
  //   icon: <QuickStartIcon />,
  //   to: "/onboarding?from=dashboard",
  // },
  {
    id: "dashboard",
    text: "Dashboard",
    icon: <DasboardIcon />,
    to: "/account/dashboard",
  },
  {
    id: "project-queue",
    text: "Project Queue",
    icon: <TaskIcon />,
    to: "/account/project-queue",
  },
  {
    id: "projects",
    text: "Projects",
    icon: <ProjectIcon />,
    to: "/account/projects",
  },
  {
    id: "call_history",
    text: "Call History",
    icon: <CallHistoryIcon />,
    to: "/account/call-history",
  },
  {
    id: "test_customer",
    text: "Test Customer",
  icon: <GroupOutlinedIcon sx={{ fontSize: 21 }} />,
    to: "/account/test-customer",
  },
  {
    id: "project_call_settings",
    text: "Project Call Settings",
    icon: <SettingsPhoneRoundedIcon sx={{ fontSize: "21px" }} />,
    to: "/account/project-call-settings",
  },
  {
    id: "agents",
    text: "Agents",
    icon: <SmartToyOutlinedIcon sx={{ fontSize: "21px" }} />,
    to: "/account/agents",
  },
  {
    id: "audiences",
    text: "Audiences",
    icon: <PeopleAltOutlinedIcon sx={{ fontSize: "21px" }} />,
    to: "/account/audiences",
  },
  {
    id: "campaigns",
    text: "Campaigns",
    icon: <CampaignOutlinedIcon sx={{ fontSize: "21px" }} />,
    to: "/account/campaigns",
  },
  {
    id: "call-settings",
    text: "Call Settings",
    icon: <SettingsPhoneOutlinedIcon sx={{ fontSize: "21px" }} />,
    to: "/account/call-settings",
  },
  // {
  //   id: "custom_dashboard",
  //   text: "Custom Dashboard",
  //   icon: <DashboardCustomizeIcon fontSize="small" />,
  //   to: "/account/leads-dashboard",
  // },
  {
    id: "leads",
    text: "Leads",
    icon: <DashboardCustomizeIcon fontSize="small" />,
    to: "/account/leads",
  },
  {
    id: "workflows",
    text: "Workflows",
    icon: <AccountTreeIcon fontSize="small" />,
    to: "/account/workflows",
  },
  {
    id: "dnc_list",
    text: "DNC List",
    icon: <BlockIcon fontSize="small" />,
    to: "/account/dnc-list",
  },
  {
    id: "campaigns-running",
    text: "Campaigns Running",
    icon: <Call />,
    to: "/account/running-campaign",
  },
  {
    id: "payments",
    text: "Payments",
    icon: <PaymentIcon style={{ fontSize: 22 }} />,
    to: "/account/payments",
  },
  {
    id: "gateway_config",
    text: "Gateway Configuration",
    icon: <Signal size={20} />,
    to: "/account/gateway-configuration",
  },
  {
    id: "gateway-performance",
    text: "Gateway Performance",
    icon: <BarChart3 size={20} />,
    to: "/account/gateway-performance",
  },
  {
    id: "constants",
    text: "Constants",
    icon: <ConstantsIcon style={{ fontSize: 22 }} />,
    to: "/account/constants",
  },
  {
    id: "links",
    text: "Links",
    icon: <LinkIcon style={{ fontSize: 22 }} />,
    to: "/account/links",
  },
];

const secondaryMenuItems = [
  {
    id: "admin",
    text: "Admin Control",
    icon: <AdminIcon />,
    to: "/account/admin",
  },
  {
    id: "settings",
    text: "Settings",
    icon: <SettingsIcon />,
    to: "/account/access",
  },
  {
    id: "support",
    text: "Support",
    icon: <SupportIcon />,
    to: "/account/support-email",
  },
];

const adminRoutes = [
  { id: "admin", to: "/account/admin" },
  {
    to: "/account/account-topup",
  },
  {
    to: "/account/recharge",
  },
];

const settingsRoutes = [
  { to: "/account/access" },
  {
    to: "/account/voice-cloning",
  },
  { to: "/account/history" },
  { to: "/account/integrations" },
];

export default function MainLayout() {
  const reducer = useSelector((reducer: any) => reducer);
  const {
    AccountReducer: {
      userDetails: { role },
      accountRoles,
      selectedAccount,
      constantData,
      userDetails,
    },
  } = reducer;

  const [open, setOpen] = useState(false);
  const [activeItemId, setActiveItemId] = useState("dashboard");
  const [showSettings, setShowSettings] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [access, setAccess] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [profilePop, setProfilePopUp] = useState(false);

  const location = useLocation();
  const currentPath = location?.pathname;
  const theme = useTheme();
  const styles = leftMenuStyle(theme, open);
  const isProjectDetailPage =
    !hasCampaignsAccess(accountRoles) &&
    location.pathname.startsWith("/account/project/") &&
    location.pathname !== "/account/projects";
  const hasCustomProjectAccess = accountRoles?.accessRole?.mainAccess === 753;

  useEffect(() => {
    let acc: any = checkRolesAccess(accountRoles);
    setAccess(acc);
  }, [accountRoles]);

  useEffect(() => {
    setOpen(false);
  }, [isProjectDetailPage]);

  useEffect(() => {
    const updateActiveItem = () => {
      if (currentPath.includes("/account/project/")) {
        return "projects";
      }
      const activeMenu = [...menu, ...secondaryMenuItems].find(
        (item) => item.to === currentPath
      );
      if (activeMenu) {
        return activeMenu.id;
      }

      if (settingsRoutes.some((route) => route.to === currentPath)) {
        return "settings";
      }
      if (adminRoutes.some((route) => route.to === currentPath)) {
        return "admin";
      }
      return null;
    };

    const activeId = updateActiveItem();
    if (activeId) {
      setActiveItemId(activeId);
    }
  }, [currentPath]);

  const handleDrawer = () => {
    setOpen((prev) => !prev);
    setAnchorEl(null);
  };

  const toggleProfilePopup = () => {
    setProfilePopUp((prev) => !prev);
  };

  const menuItems = menu.filter((item) => {
    if (
      hasCustomProjectAccess &&
      !(hasCallHistoryAccess(accountRoles) || hasCampaignsAccess(accountRoles))
    ) {
      return ["projects", "call_history"].includes(item.id);
    }
    if (["audiences", "campaigns", "call-settings"].includes(item.id)) {
      return hasCampaignsAccess(accountRoles);
    }
    if (
      hasCallHistoryAccess(accountRoles) ||
      hasCampaignsAccess(accountRoles)
    ) {
      const agentAccessible =
        hasCampaignsAccess(accountRoles) ||
        !hasOnlyCallHistoryAccess(accountRoles);
      return agentAccessible
        ? ["call_history", "agents"].includes(item.id)
        : ["call_history"].includes(item.id);
    }

    if (item.id === "agents") {
      return (
        hasCampaignsAccess(accountRoles) ||
        (hasCallHistoryAccess(accountRoles) &&
          !hasOnlyCallHistoryAccess(accountRoles))
      );
    }
    // if (item.id === "quick_start") {
    //   return checkRolesAccess(accountRoles, "projectPage");
    // }
    if (["leads", "constants", "workflows", "links"].includes(item.id)) {
      return selectedAccount?.params?.leadsConstantsWorkflows;
    }

    if (item.id === "dashboard") {
      return access === "dashboard";
    }
    if (item.id === "project-queue") {
      return selectedAccount?.params?.projectQueue;
    }

    if (item.id === "campaigns-running") {
      return selectedAccount?.params?.liveCampaigns;
    }
    if (item.id === "cps-settings") {
      return selectedAccount?.params?.cpsAccess;
    }
    if (item.id === "capacity-settings") {
      return selectedAccount?.params?.capacityAccess;
    }
    if (item.id === "dnc_list") {
      return selectedAccount?.params?.dnc;
    }
    if (item?.id === "gateway_config") {
      return constantData?.gatewayConfig;
    }
    if (item?.id === "gateway-performance") {
      return constantData?.gatewayConfig;
    }

    if (item.id === "gateway") {
      if (!constantData?.gateways) return false;
      const isDefault = constantData?.gateways?.some(
        (g) => g?.default === true
      );
      return !isDefault;
    }
    if (item.id === "payments") {
      return isVodexLoggedin() && isAdmin(selectedAccount, userDetails);
    }

    return true;
  });

  const secondaryMenu = secondaryMenuItems?.filter(({ id }) => {
    switch (id) {
      case "settings":
        return access === "dashboard";
      case "admin":
        return ["super_admin", "admin", "sales"].includes(role);
      case "support":
        return isVodexLoggedin();
      default:
        return true;
    }
  });

  let sidebarObj = {
    setShowSettings,
    activeItemId,
    setActiveItemId,
    secondaryMenu,
    setShowAdmin,
    adminRoutes,
    settingsRoutes,
    isProjectDetailPage,
    editModalOpen,
    setEditModalOpen,
    setAnchorEl,
    anchorEl,
    setProfilePopUp,
  };

  return (
    <Box className="main-layout-container">
      <CssBaseline />
      <Box className="top-bar-container">
        <Topbar
          showAdminControls={showAdmin}
          styles={styles}
          open={open}
          showSettings={showSettings}
        />
      </Box>
      {!isProjectDetailPage && (
        <Box
          sx={[
            {
              display: { xs: "none", lg: "block" },
            },
            open ? styles.leftPointer : styles.rightPointer,
          ]}
        >
          {open ? (
            <LeftPointer onClick={handleDrawer} />
          ) : (
            <RightPointer onClick={handleDrawer} />
          )}
        </Box>
      )}
      <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
        <Sidebar
          styles={styles}
          menuItems={menuItems}
          open={open}
          obj={sidebarObj}
        />
        {isProjectDetailPage && (
          <ProjectSidebar
            setEditModalOpen={setEditModalOpen}
            drawerOpen={open.toString()}
          />
        )}
        <Box
          sx={{
            ...layoutStyles.outerAppContainer,
            marginLeft: isProjectDetailPage ? "200px" : "0",
          }}
        >
          <Box className="flex-column inner-main-container">
            <Box sx={layoutStyles.innerAppContainer}>
              <NewRoutes />
            </Box>
          </Box>
        </Box>
      </Box>
      {profilePop && (
        <CommonPopup
          message={`Profile updated Successfully`}
          show={profilePop}
          toggle={toggleProfilePopup}
          Icon={SuccessIcon}
          heading="Profile Updated"
        />
      )}
    </Box>
  );
}
